/**
 * A pasted link, ready to store or turn into an anchor: a bare host gets https,
 * an http(s) link is kept as it is, and anything carrying another scheme comes
 * back EMPTY. Registrants click these, so a `javascript:` or `data:` URL must
 * never survive the trip through a post body or an offer button.
 */
export function normUrl(u: string): string {
  const v = (u ?? "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  // Mail and phone links are real links, and neither uses "//".
  if (/^(mailto|tel):/i.test(v)) return v;
  // A scheme is only a scheme when "//" follows it, so "myhost.co.uk:8080/book"
  // is a host and a port, not a protocol. The scheme-only forms that can run
  // something are named, and refused outright.
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(v)) return "";
  if (/^(javascript|data|vbscript|file|blob|about|filesystem):/i.test(v)) return "";
  return `https://${v}`;
}
